import { create } from "zustand";
// Errors stay longer so the operator has time to read them. Defaults are
// intentionally generous on the Till — owner verifies by clicking, not by
// staring at the screen.
const DEFAULT_DURATION = {
    success: 4000,
    info: 4000,
    warning: 6000,
    error: 8000,
};
const MAX_VISIBLE = 5;
let counter = 0;
const nextId = () => `t-${Date.now()}-${++counter}`;
export const useToastStore = create((set) => ({
    toasts: [],
    push: (variant, input) => {
        const id = nextId();
        const message = typeof input === "string" ? input : input.message;
        const duration = typeof input === "object" && input.duration !== undefined
            ? input.duration
            : DEFAULT_DURATION[variant];
        set((s) => {
            const next = [...s.toasts, { id, variant, message, duration }];
            while (next.length > MAX_VISIBLE)
                next.shift();
            return { toasts: next };
        });
        return id;
    },
    dismiss: (id) => {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    },
    clear: () => set({ toasts: [] }),
}));
/**
 * Imperative toast API — call from anywhere (adapters, async handlers,
 * non-React code). Each call returns the toast id so the caller can dismiss
 * it manually if needed (e.g. swap a "saving…" toast for a "saved" one).
 */
export const toast = {
    success: (input) => useToastStore.getState().push("success", input),
    error: (input) => useToastStore.getState().push("error", input),
    info: (input) => useToastStore.getState().push("info", input),
    warning: (input) => useToastStore.getState().push("warning", input),
    dismiss: (id) => useToastStore.getState().dismiss(id),
    clear: () => useToastStore.getState().clear(),
};
//# sourceMappingURL=toastStore.js.map